import { TAdminRole } from '@mybonum/api';

import { TAdminRoles } from '@/types.ts';

export const ADMIN_ROLE_OPTION_LABELS: Record<TAdminRoles, string> = {
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'Admin',
};

export const ROLE_TO_ENUM_MAP: Record<TAdminRoles, TAdminRole> = {
    SUPER_ADMIN: 2,
    ADMIN: 1,
};
